import { isDefined } from "../../shared/utils";

export default class Indicatrix {
  constructor(canvas, center = { x: 512, y: 384 }) {
    this._canvas = canvas;
    this._previewImageSize = {
      width: 1024,
      height: 768
    };
    this._center = center || {
      x: 512,
      y: 384
    };
    this._ctx = this._canvas.getContext("2d");
    this._width = this._canvas.getBoundingClientRect().width;
    this._height = this._canvas.getBoundingClientRect().height;
    this._canvas.width = this._width;
    this._canvas.height = this._height;
    this._zoom = 1;
    this._radio_w = (this._width * 1.0) / this._previewImageSize.width;
    this._radio_h = (this._height * 1.0) / this._previewImageSize.height;
    this._startX = this._radio_w * this._center.x;
    this._startY = this._radio_h * this._center.y;
    this._ctx.strokeStyle = "#fff";
    this._ctx.lineWidth = 2;
    this.verteices = [1, 1, -1, 1, 1, -1, -1, -1];
    this._zoom = 1;
  }
  clearDraw() {
    this._clearDraw();
  }
  _clearDraw() {
    this._ctx.restore("clear");
    this._ctx.clearRect(0, 0, this._width, this._height);
    this._ctx.save("clear");
  }
  drawCross(x = 0, y = 0, zoom = 1) {
    this._clearDraw();
    const { CROSSSIZE, LINEWIDTH, LINECOLOR } = window.ctShotInfo.previewIndicatrix;
    this._ctx.save("translate");
    let offsetY = 0;
    let offsetX = 0;
    this.verteices = [1, 1, -1, 1, 1, -1, -1, -1];
    // if (isDefined(zoom)) {
    //   var zlt = zoom / this._zoom
    //   if (zoom < 1.0 || zoom > 3.0) return
    //   // new Float32Array([1, 1, -1, 1, 1, -1, -1, -1]);
    //   var wl = x - this.verteices[2]
    //   var ht = this.verteices[1] - y
    //   wl = zlt * wl
    //   ht = zlt * ht
    //   var xl = x - wl
    //   var yt = y + ht
    //   if (xl > -1.0) { xl = -1.0 }
    //   if (yt < 1.0) { yt = 1.0 }
    //   var xr = xl + (zoom * 2.0)
    //   var yb = yt - (zoom * 2.0)
    //   if (xr < 1.0) {
    //     xr = 1.0
    //     xl = xr - (zoom * 2.0)
    //   }
    //   if (yb > -1.0) {
    //     yb = -1.0
    //     yt = yb + (zoom * 2.0)
    //   }
    //   this.verteices[0] = xr
    //   this.verteices[1] = yt
    //   this.verteices[2] = xl
    //   this.verteices[3] = yt
    //   this.verteices[4] = xr
    //   this.verteices[5] = yb
    //   this.verteices[6] = xl
    //   this.verteices[7] = yb
    //   this._zoom = zoom
    //   offsetX = (this._width * xr + this._width * xl) / 2
    //   offsetY = (this._width * yb + this._width * yt) / 2
    // }
    this._ctx.translate(this._radio_w * x + offsetX, this._radio_h * y - offsetY);
    // console.log(
    //   this._radio_w * x,
    //   x,
    //   this._radio_h * y,
    //   y,
    //   '================='
    // )
    // this._ctx.setLineDash([6])
    // this._ctx.lineDashOffset = 0
    this._ctx.beginPath();
    this._ctx.strokeStyle = LINECOLOR;
    this._ctx.lineWidth = LINEWIDTH + 1;
    this._ctx.moveTo(-CROSSSIZE, 0);
    this._ctx.lineTo(CROSSSIZE, 0);
    this._ctx.stroke();
    this._ctx.beginPath();
    this._ctx.moveTo(0, -CROSSSIZE);
    this._ctx.lineTo(0, CROSSSIZE);
    this._ctx.stroke();
    this._ctx.beginPath();
    this._ctx.arc(0, 0, CROSSSIZE, 0, Math.PI * 2);
    this._ctx.stroke();
    this._ctx.restore("translate");
  }
  drawSemicircle(updown) {
    this._clearDraw();
    const { LINEWIDTH, LINECOLOR } = window.ctShotInfo.previewIndicatrix;
    this._ctx.save("translate");
    const PADDINGLEFT = this._width * 0.1;
    let PADDINGRIGHT = this._width * 0.1;
    let PADDINGTOP = 300;
    let PADDINGBOTTOM = 350;
    const LINEHEIGHT = 100;
    this._ctx.lineWidth = LINEWIDTH;
    this._ctx.setLineDash([10, 8]);
    this._ctx.lineDashOffset = 4;
    let lineHight = updown === "down" ? LINEHEIGHT : -LINEHEIGHT;
    this._ctx.strokeStyle = LINECOLOR;
    let center = {
      x: this._width / 2
    };
    center.y = updown === "down" ? PADDINGTOP : this._height - PADDINGBOTTOM;
    this._ctx.beginPath();
    this._ctx.translate(center.x, center.y);
    this._ctx.beginPath();
    this._ctx.moveTo(-(this._width / 2 - PADDINGLEFT), lineHight);
    this._ctx.lineTo(-(this._width / 2 - PADDINGLEFT), 0);
    this._ctx.lineTo(this._width / 2 - PADDINGRIGHT, 0);
    this._ctx.lineTo(this._width / 2 - PADDINGRIGHT, lineHight);
    this._ctx.bezierCurveTo(
      (this._width / 2 - PADDINGRIGHT) / 2,
      lineHight * 2 * 2,
      -(this._width / 2 - PADDINGRIGHT) / 2,
      lineHight * 2 * 2,
      -(this._width / 2 - PADDINGLEFT),
      lineHight
    );
    this._ctx.stroke();
    this._ctx.restore("translate");
  }
}



// WEBPACK FOOTER //
// ./src/mainInterface/js/PreviewIndicatrix.js